module.exports = require("net");


//////////////////
// WEBPACK FOOTER
// external "net"
// module id = 45
// module chunks = 0